import {
  configureStore as configureStoreRTK,
  AnyAction,
  CombinedState,
  EnhancedStore,
  ThunkMiddleware,
  ThunkAction,
  Action,
} from '@reduxjs/toolkit';
import { appStateReducer } from '../reducers/appState';
import { domainReducer } from '../reducers/domain';
import { requestsStateReducer } from '../reducers/requestsState';
import { uiStateReducer } from '../reducers/ui';
import { IStoreState } from '../types/StoreState';
import { middlewares } from './middlewares';

let store: EnhancedStore<
  CombinedState<IStoreState>,
  AnyAction,
  [ThunkMiddleware<CombinedState<IStoreState>, AnyAction, undefined>]
>;

export const configureStore = (initialState?: Partial<IStoreState>) => {
  store = configureStoreRTK({
    reducer: {
      appState: appStateReducer,
      domain: domainReducer,
      ui: uiStateReducer,
      requestsState: requestsStateReducer,
    },
    middleware: middlewares,
    preloadedState: initialState,
  });

  return store;
};

export type Store = EnhancedStore<
  CombinedState<IStoreState>,
  AnyAction,
  [ThunkMiddleware<CombinedState<IStoreState>, AnyAction, undefined>]
>;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
